const HttpResponseEmun = Object.freeze({
    OK: 202,
    BadRequest: 400,
    Unauthorized: 403,
    NotFound: 404,
    InternalServerError: 500,
  })
  
  export default HttpResponseEmun